/**
 * Typed inventory label API facade over the generated contract client.
 */

import { inventoryLabelsApi } from '../api/generated/inventoryLabels.api.js';
import {
  type InventoryLabelResolveResponse,
  type LastBarcodeScanPayload,
} from '@cnapse/shared/inventory-label.js';
import { type LabelLinkHandheldSession } from '@cnapse/shared/label-link-handheld-session.js';

class InventoryLabelsService {
  async resolveInventoryLabel(barcode: string): Promise<InventoryLabelResolveResponse> {
    return inventoryLabelsApi.resolve({ barcode }) as Promise<InventoryLabelResolveResponse>;
  }

  async getLastInventoryBarcodeScan(): Promise<LastBarcodeScanPayload | null> {
    return inventoryLabelsApi.getLastScan() as Promise<LastBarcodeScanPayload | null>;
  }

  async assignInventoryLabelToContainer(
    barcode: string,
    entityId: number,
    options?: { replaceExisting?: boolean },
  ): Promise<void> {
    await inventoryLabelsApi.assign({
      barcode,
      entityType: 'container',
      entityId,
      replaceExisting: options?.replaceExisting ?? false,
    });
  }

  async createLabelLinkHandheldSession(): Promise<LabelLinkHandheldSession> {
    return inventoryLabelsApi.createHandheldSession({}) as Promise<LabelLinkHandheldSession>;
  }

  async getLabelLinkHandheldSession(sessionId: string): Promise<LabelLinkHandheldSession> {
    return inventoryLabelsApi.getHandheldSession(sessionId) as Promise<LabelLinkHandheldSession>;
  }

  async cancelLabelLinkHandheldSession(sessionId: string): Promise<void> {
    await inventoryLabelsApi.cancelHandheldSession(sessionId);
  }

  async clearLabelLinkHandheldScan(sessionId: string): Promise<LabelLinkHandheldSession> {
    return inventoryLabelsApi.clearHandheldScan(sessionId) as Promise<LabelLinkHandheldSession>;
  }
}

export const inventoryLabelsService = new InventoryLabelsService();
